const DEFAULT_PATH = "https://cdn.vip-wifi.com/fangchan/config/"
import wx from '@/utils/wx'

export const request = (path) => {
    return new Promise((resovle, reject) => {
        wx.request({
            url: `${DEFAULT_PATH}${path}.json`,
            data: {
                v: new Date().getTime()
            },
            success: (res) => {
                console.error('load config success', res)
                const { data, statusCode } = res
                if (statusCode === 200) {
                    resovle(data)
                }
                reject(res)
            },
            fail (err) {
                reject(err)
            }
        })
    })
}

const getDisclaimerConfig = () => request('pages/disclaimer_list/config')
const getHomePage = () => request('home_tabs')
const getTeam = () => request('pages/team/config')
const getCheckCondition = () => request('pages/check_condition/config')
const getThematicBuilding = () => request('pages/thematic_building/config')
const getConsultantBidding = () => request('pages/consultant_bidding/config')
const getSurplusBuildingEvent = () => request('pages/surplus_building_event/config')
const getOrderCheck = () => request('pages/packageA/order_check/config')
const getNconv = () => request('pages/packageA/nconv2019_zones/config')
const getDevActivityConfig = () => request('pages/dev_activity/config')
const getConsultantActivity = () => request('pages/consultant_activity/config')
const getMetroLines = () => request('public/metro_lines')

export default {
    getDisclaimerConfig,
    getHomePage,
    getTeam,
    getCheckCondition,
    getThematicBuilding,
    getConsultantBidding,
    getSurplusBuildingEvent,
    getOrderCheck,
    getNconv,
    getDevActivityConfig,
    getConsultantActivity,
    getMetroLines
}